import { CloseIcon } from '@chakra-ui/icons';
import { Button, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, IconButton } from '@chakra-ui/react';
import Spinner from 'components/spinner/Spinner';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getApi, putApi } from 'services/api';
import { generateValidationSchema } from '../../../utils';
import * as yup from 'yup'
import CustomForm from 'utils/customForm';
import { postApi } from 'services/api';
import { deleteApi } from 'services/api';
import { ToastContainer, toast } from "react-toastify";
import { FcCancel } from "react-icons/fc";

const Edit = (props) => {
    const { data } = props;
    //console.log(props.contactData,".......gfdsf.............")
    const [isLoding, setIsLoding] = useState(false)
    const initialFieldValues = Object.fromEntries(
        (props?.contactData?.fields || []).map(field => [field?.name, ''])
    );
    //console.log(initialFieldValues,"............initialFieldValues............")
    const [initialValues, setInitialValues] = useState({
        ...initialFieldValues,
        createBy: JSON.parse(localStorage.getItem('user'))._id
    });
    const param = useParams()

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: yup.object().shape(generateValidationSchema(props?.contactData?.fields)),
        onSubmit: (values, { resetForm }) => {
            EditData();
        },
    });

    const { errors, touched, values, handleBlur, handleChange, handleSubmit, setFieldValue, } = formik

    let[isEdited,setIsEdited]=useState(false)
    let[call,setCall]=useState(0)


    const EditData = async () => {
        try {
            setIsLoding(true);
            //console.log(values,"............values............")
            let commentsArray = Array.isArray(values.comments)
                ? values.comments
                : [{ 
                    comment: values.comments, 
                    createdAt: new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) 
                }];


                setIsEdited(!isEdited)
                if(isEdited){

                    setCall(call+1)
                }
                //console.log("dialed",call);
    
            // Update the contact
            let response = await putApi(`api/form/edit/${props?.selectedId || param.id}`, {
                ...values,
                moduleId: props?.moduleId,
                comments: commentsArray, 
                isEdited:(values.isEdited || 0)  +1 // Ensure comments are sent as an array
            });

            //console.log("send edit data",response );
            
                const selectedRemark = values?.leadRemark;
                let selectedStatus;
                //console.log("selected remark...............",selectedRemark)
                switch (selectedRemark) {
                    case "rnr":
                    case "notInterested":
                    case "busy":
                    case "notReachable":
                    case "currentlyNotInterested":
                    case "leadLost":
                        selectedStatus = "cold"; // Return 'cold' status
                        break;
    
                    case "followUp":
                    case "visitScheduled":
                    case "visitReschedule":
                    case "videoCallScheduled":
                    case "videoCallReschedule":
                        selectedStatus = "warm"; // Return 'warm' status
                        break;
                    case "OfficeVisitSchedule":
                    case "OfficeVisitReschedule":
                    case "visitedDone":
                    case "bookingDone":
                        selectedStatus = "hot"; // Return 'hot' status
                        break;
                    case "salesClosed":
                    case "alreadyPurchased":
                        selectedStatus="booked";
                        break;
                    default:
                        selectedStatus = "pending"; // Default case if no match
                        break;
                }
    
                //console.log("Selected Status: ", selectedStatus);
                if (response.status === 200 && (selectedStatus === "warm" || selectedStatus === "hot"||selectedStatus==="booked"))
                    {
                       
                // Prepare lead data based on contact values
                const leadData = {
                    ...values, // Spread all the contact fields
                    leadStatus: selectedStatus, // Set the determined status
                    leadName: values?.ContactName,
                    leadEmail: values?.email,
                    comments:commentsArray,
                    leadRemark: values?.leadRemark,
                    leadPhoneNumber: values?.phoneNumber,
                    origin: values?.origin,
                    isEdited:(values?.isEdited || 0)  +1,
                    assignedTo:values?.assignedTo,
                    budget: 0,
                    type: "",
                    location: "",
                    source: "Contact Conversion", // Optional: Add any specific flag
                    createBy: JSON.parse(localStorage.getItem("user"))._id, // Add user details if needed
                    updateBy:JSON.parse(localStorage.getItem("user"))._id,
                };
    
                                    toast.success("Contact Updated successfully!", {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    icon: "✅",
                                    style: {
                                      backgroundColor: "#fffff", // Green background
                                      color: "green",
                                      fontSize: "16px",
                                      borderRadius: "8px",
                                    },
                                  });
    
                // Post the new lead
                let leadResponse = await postApi(`api/lead/add`, leadData);
                //console.log("leadResponse.....................+++++++++++++++++++++++++",leadResponse);
                if (leadResponse.status === 200) {
                    //console.log("Lead added successfully from contact.");
                    toast.success(" Updated successfully and Moved to Lead !", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        icon: "✅",
                        style: {
                          backgroundColor: "#fffff", // Green background
                          color: "green",
                          fontSize: "16px",
                          borderRadius: "8px",
                        },
                      });
                    let response = await deleteApi(
                        `api/contact/delete/`,`${props?.selectedId || param.id}`)
                        //console.log("response.....................+++++++++++++++++++++++++",response);
                } else {
                    console.error("Failed to add the lead:", leadResponse);
                      toast.error("Failed to add the lead:", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        icon: <FcCancel />,
                                        style: {
                                          backgroundColor: "#fffff",
                                          color: "red",
                                          fontSize: "16px",
                                          borderRadius: "8px",
                                        },
                                      });
                }
    
                // Close the modal and refresh the action
                props.onClose();
                props.setAction((prev) => !prev);
            }else if(response.status === 200 && (selectedStatus==='cold')){
                props.onClose();
                props.setAction((prev) => !prev);
            }
            setIsEdited(!isEdited)
        } catch (error) {
            console.error("Error during contact edit and lead conversion:", error);
        } finally {
            setIsLoding(false);
        }
    };
    
    

// const EditData = async () => {
//     try {
//         setIsLoding(true);
//         //console.log(values, "............values............");

//         // ✅ Convert comments array into a single string
//         const formattedComments = values?.comments
//             ?.map(c => `${c.comment} (${c.createdAt})`)
//             .join("\n") || "";

//         // ✅ Update the values object with formatted comments
//         let updatedValues = {
//             ...values,
//             comments: formattedComments, // Convert array to string
//             moduleId: props?.moduleId,
//         };

//         // 🔥 Send updated values to API
//         let response = await putApi(`api/form/edit/${props?.selectedId || param.id}`, updatedValues);

//         // Determine lead status based on remark
//         const selectedRemark = values?.leadRemark;
//         let selectedStatus;
//         //console.log("selected remark...............", selectedRemark);
//         switch (selectedRemark) {
//             case "rnr":
//             case "notInterested":
//             case "busy":
//             case "notReachable":
//             case "currentlyNotInterested":
//             case "leadLost":
//                 selectedStatus = "cold"; // Return 'cold' status
//                 break;
//             case "followUp":
//             case "visitScheduled":
//             case "visitReschedule":
//             case "videoCallScheduled":
//             case "videoCallReschedule":
//                 selectedStatus = "warm"; // Return 'warm' status
//                 break;
//             case "OfficeVisitSchedule":
//             case "OfficeVisitReschedule":
//             case "visitedDone":
//             case "bookingDone":
//                 selectedStatus = "hot"; // Return 'hot' status
//                 break;
//             case "salesClosed":
//             case "alreadyPurchased":
//                 selectedStatus = "booked";
//                 break;
//             default:
//                 selectedStatus = "pending"; // Default case if no match
//                 break;
//         }

//         //console.log("Selected Status: ", selectedStatus);
//         if (response.status === 200 && (selectedStatus === "warm" || selectedStatus === "hot" || selectedStatus === "booked")) {
//             // Prepare lead data based on updated values
//             const leadData = {
//                 ...updatedValues, // Use formatted comments
//                 leadStatus: selectedStatus,
//                 leadName: values?.ContactName,
//                 leadEmail: values?.email,
//                 leadRemark: values?.leadRemark,
//                 leadPhoneNumber: values?.phoneNumber,
//                 origin: values?.origin,
//                 budget: 0,
//                 type: "",
//                 location: "",
//                 source: "Contact Conversion",
//                 createBy: JSON.parse(localStorage.getItem("user"))._id,
//                 updateBy: JSON.parse(localStorage.getItem("user"))._id,
//             };

//             // Post the new lead
//             let leadResponse = await postApi(`api/lead/add`, leadData);
//             //console.log("leadResponse.....................+++++++++++++++++++++++++", leadResponse);
//             if (leadResponse.status === 200) {
//                 //console.log("Lead added successfully from contact.");
//                 let response = await deleteApi(`api/contact/delete/`, `${props?.selectedId || param.id}`);
//                 //console.log("response.....................+++++++++++++++++++++++++", response);
//             } else {
//                 console.error("Failed to add the lead:", leadResponse);
//             }

//             // Close the modal and refresh
//             props.onClose();
//             props.setAction(prev => !prev);
//         } else if (response.status === 200 && selectedStatus === "cold") {
//             props.onClose();
//             props.setAction(prev => !prev);
//         }
//     } catch (error) {
//         console.error("Error during contact edit and lead conversion:", error);
//     } finally {
//         setIsLoding(false);
//     }
// };

    const handleClose = () => {
        props.onClose(false)
        props.setSelectedId && props?.setSelectedId()
    }
    let response
    const fetchData = async () => {
        if (data) {
            setInitialValues((prev) => ({ ...prev, ...data }))
        } else if (props?.selectedId || param.id) {
            try {
                setIsLoding(true)
                response = await getApi('api/contact/view/', props?.selectedId ? props?.selectedId : param.id)
                setInitialValues((prev) => ({ ...prev, ...response?.data?.contact}))
            } catch (e) {
                console.error(e)
            } finally {
                setIsLoding(false)
            }
        }
    }
    useEffect(() => {
        fetchData()
    }, [props?.selectedId, data])

    return (
        <div>
            <Drawer isOpen={props.isOpen} size={props.size}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader alignItems={"center"} justifyContent='space-between' display='flex' >
                        Edit Contact
                        <IconButton onClick={handleClose} icon={<CloseIcon />} />
                    </DrawerHeader>
                    <DrawerBody>
                        {isLoding ?
                            <Flex justifyContent={'center'} alignItems={'center'} width="100%" >
                                <Spinner />
                            </Flex>
                            :

                            <CustomForm moduleData={props.contactData} values={values} setFieldValue={setFieldValue} handleChange={handleChange} handleBlur={handleBlur} errors={errors} touched={touched} />

                        }
                    </DrawerBody>

                    <DrawerFooter>
                        <Button
                            sx={{ textTransform: "capitalize" }}
                            variant="brand"
                            type="submit" size="sm"
                            disabled={isLoding ? true : false}
                            onClick={handleSubmit}
                        >
                            {isLoding ? <Spinner /> : 'Update'}
                        </Button>
                        <Button
                            variant="outline"
                            colorScheme='red' size="sm"
                            sx={{
                                marginLeft: 2,
                                textTransform: "capitalize",
                            }}
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
            <ToastContainer />
        </div>
    )
}

export default Edit